
import { INSERIR_DADOS_ACESSO, LIMPAR_DADOS_ACESSO, EXPIRAR_SESSAO } from './loginActions';

export const INITIAL_STATE = {
  laboratorio: null,
  usuario: null,
  loginExterno: null,
  dataExpiracao: null,
  acessoNegado: false,
  sessaoExpirada: false,
  tempoRenovarSessao: null,
  usuarioAutenticado: false,
  validacaoLaboratorio: null,
};

export default (state, action) => {
  if (!state) state = INITIAL_STATE;
  switch (action.type) {
    case INSERIR_DADOS_ACESSO:
      return {
        ...state,
        laboratorio: action.payload.laboratorio,
        usuario: action.payload.usuario,
        loginExterno: action.payload.loginExterno,
        dataExpiracao: action.payload.dataExpiracao,
        tempoRenovarSessao: null,
        acessoNegado: false,
        sessaoExpirada: false,
      };

    case LIMPAR_DADOS_ACESSO:
      return {
        ...INITIAL_STATE,
        acessoNegado: true,
        loginExterno: state.loginExterno
      };

    case EXPIRAR_SESSAO:
      return {
        ...state,
        sessaoExpirada: true,
        tempoRenovarSessao: action.payload,
      };

    default:
      return state;
  }
};